import { baseCellStyles } from '../cells.consts';
import { ITableStickyColumn } from '../../table.interfaces';
import { MuiTableCell, styled } from '../../../base-components';
import { shouldForwardProp } from '@mui/system';

const customShouldForwardProp = (prop: PropertyKey) =>
    shouldForwardProp(prop) &&
    ![
        'stickyColumn',
        'rowStickyWidths',
        'columnIndex',
        'isSelected',
        'isHeaderCell',
    ].includes(prop as string);

export const StyledTableCell = styled(MuiTableCell, {
    shouldForwardProp: customShouldForwardProp,
})<{
    alignment: string;
    stickyColumn?: ITableStickyColumn;
    rowStickyWidths?: Array<number>;
    columnIndex?: number;
    isSelected?: boolean;
    isHeaderCell?: boolean;
}>(({
    theme,
    alignment: alignment,
    stickyColumn: stickyColumn,
    rowStickyWidths: rowStickyWidths,
    columnIndex: columnIndex,
    isSelected: isSelected,
    isHeaderCell: isHeaderCell,
}) => {
    const baseStyles = baseCellStyles(
        theme,
        alignment,
        stickyColumn,
        rowStickyWidths,
        columnIndex,
        isSelected
    );
    return {
        ...baseStyles,
        textAlign: 'center',
        backgroundColor: isHeaderCell ? '#F3F2F2' : undefined, //TODO: THEME!
        borderTop: isHeaderCell
            ? `1px solid ${theme.palette.grey[200]}`
            : undefined,
        borderBottom: isHeaderCell
            ? `1px solid ${theme.palette.grey[200]}`
            : undefined,
    };
});
